import type { Action } from 'state/actions';

import { initialProductDescriptionState, type ProductDescriptionState } from './model';

export function productDescriptionReducer(
  state: ProductDescriptionState = initialProductDescriptionState,
  action: Action,
): ProductDescriptionState {
  switch (action.type) {
    case 'PRODUCT_DESCRIPTIONS_REQUESTED':
      return { ...state, status: 'loading' };
    case 'PRODUCT_DESCRIPTIONS_TIMEOUTED':
      return { ...state, status: 'timeout' };
    case 'PRODUCT_DESCRIPTIONS_FAILED':
      return { ...state, status: 'error' };
    case 'PRODUCT_DESCRIPTIONS_RECEIVED':
      return { ...action.data, status: 'success' };

    default:
      return state;
  }
}
